import ResponsiveImage from '~/components/Image/ResponsiveImage'

export default function AiIcon({ className = '' }: { className?: string }): React.ReactElement {
  const mediaQuery = [{ screen: '(min-width: 280px)', width: '44px' }]
  return (
    <div className="relative min-w-12 my-auto">
      <ResponsiveImage
        className={`w-12 ${className}`}
        height={120}
        imageClassName="w-full"
        imageWidths="160"
        mediaQuery={mediaQuery}
        srcKey="curriculum/ai-icon.png"
        width={120}
      />
      <div className={`absolute top-0 left-0 w-full h-full ${className}`}>
        <div className="flex h-full items-center justify-center">
          <span className="gradient-ai-curriculum-text font-medium text-md">AI</span>
        </div>
      </div>
    </div>
  )
}
